import { useEffect } from 'react'
import { useReactiveVar } from '@apollo/client'
import { Card, Flex, Heading } from '@radix-ui/themes'
import { openPrivyLogin, PrivySignInButton } from 'features/auth-privy'
import { Head } from 'features/head'
import { ModeCards } from 'features/home/components/mode-cards'
import { useNavigate } from 'react-router-dom'
import { useResponsive } from 'shared/hooks/use-responsive'
import { InfoCircleIcon } from 'shared/icons'
import { userVar } from 'shared/store/user'

export const UnloggedPage: React.FC = () => {
  const user = useReactiveVar(userVar)
  const navigate = useNavigate()
  const queryString = window.location.search

  const [isMobile] = useResponsive('xs')

  // NOTE: on desktop the Privy sign-in opens right away; on a phone the page
  // keeps its own button so the modal does not cover the content unasked
  useEffect(() => {
    if (isMobile === null || isMobile) return

    openPrivyLogin()
  }, [isMobile])

  useEffect(() => {
    if (user) {
      navigate(`/${queryString}`, {
        replace: true
      })
    }
  }, [navigate, queryString, user])

  return (
    <>
      <Head title='Please sign in' />
      <Card>
        <Flex
          direction={'column'}
          gap='4'
          height='100%'
          p='4'
          align='center'
        >
          <InfoCircleIcon
            height='6rem'
            width='6rem'
            color='var(--yellow)'
          />
          <Heading mb='3'>
            This page is available only to logged-in users
          </Heading>

          <PrivySignInButton />

          <ModeCards />
        </Flex>
      </Card>
    </>
  )
}
